/** English UI — client web mockup labels + portal copy */
export const en = {
  appName: 'Mentora',
  tagline: 'Connecting students and mentors',
  login: 'Log in',
  register: 'Sign up',
  forgotPassword: 'Forgot password',
  emailOrPhone: 'Email or phone',
  password: 'Password',
  submit: 'Submit',
  backToLogin: 'Back to login',
  backToLanding: 'Back to home',
  logout: 'Log out',
  language: 'Language',
  languageEn: 'English',
  languageTr: 'Turkish',
  menuTitle: 'Menu',
  mainMenuAria: 'Main menu',
  navLockedAria: 'Locked until verification is complete',
  mobileTabMenuAria: 'Mobile tab menu',
  userDisplayFallback: 'User',
  navPanel: 'Dashboard',
  navFindMentor: 'Search Mentors',
  navFavorites: 'Favorites',
  navMyClasses: 'Lessons',
  navMessages: 'Messages',
  navPurse: 'Wallet',
  navProfile: 'Profile',
  navNotifications: 'Notifications',
  navDashboard: 'Dashboard',
  navMyListings: 'My Listings',
  navAvailability: 'Availability',
  navEarnings: 'Earnings',
  navMyStudents: 'My Students',
  navMaterials: 'Materials',
  dashboard: 'Dashboard',
  dashboardLoadError: 'Could not load dashboard',
  lessons: 'Lessons',
  noUpcomingLessons: 'No upcoming lessons',
  noUpcomingLessonsDescription: 'When a new lesson is scheduled, it will appear here.',
  noUpcomingLessonsHint: 'You can find a new mentor or review reports from past lessons.',
  noPastLessons: 'No past lessons',
  noPastLessonsDescription: 'Completed lessons will be listed here by subject or student group.',
  lessonsPageDescription: 'Track your child’s upcoming and past lessons here.',
  lessonsPageDescriptionStudent: 'Track your upcoming and past lessons here.',
  lessonsTabUpcoming: 'Upcoming',
  lessonsTabPast: 'Past',
  lessonsStudentLabel: 'Student',
  lessonsAllStudents: 'All students',
  lessonsSearchStudents: 'Search students…',
  lessonsFilterSubject: 'Subject / Service',
  lessonsFilterMentor: 'Mentor',
  lessonsFilterDateRange: 'Date range',
  lessonsViewDetails: 'View details',
  lessonsViewPastLessons: 'View past lessons',
  lessonsLastLesson: 'Last lesson: {{date}}',
  lessonsSessionCount: '{{count}} lesson sessions',
  lessonsSessionCountOne: '1 lesson session',
  lessonsStatUpcoming: 'Upcoming Lessons',
  lessonsStatCompleted: 'Completed Lessons',
  lessonsStatReportsReady: 'Reports Ready',
  lessonsStatTotalHours: 'Total Lesson Hours',
  lessonsStatNoDataYet: 'No data yet',
  lessonsHoursUnit: 'hrs',
  lessonsNextUp: 'Next lesson',
  lessonsSelectedDay: 'Sessions on',
  lessonsSessionSingular: 'session',
  lessonsSessionPlural: 'sessions',
  lessonsNoSessionsThisDay: 'No sessions on this day',
  lessonsNoSessionsThisDayHint:
    'Pick another date on the calendar — purple dots mark days with lessons.',
  lessonsLoadError: 'Could not load lessons',
  lessonsRoleRestricted: 'Lessons are only available for student, parent, or mentor accounts.',
  reportStatusReady: 'Report ready',
  reportStatusProcessing: 'Report processing',
  reportStatusNone: 'No report',
  reportStatusNotCompleted: 'Lesson not completed',
  reportStatusUnknown: 'Report status unknown',
  reportStatusWaitingLesson: 'Will be prepared after the lesson is completed',
  reportStatusSummaryReady: 'Summary ready',
  reportStatusQuizNotAssigned: 'Quiz not assigned',
  reportStatusQuizCompleted: 'Quiz completed',
  reportStatusQuizAssigned: 'Quiz assigned',
  reportStatusMentorNoteMissing: 'Mentor note not added yet',
  reportStatusMentorNoteAdded: 'Mentor note added',
  reportStatusSummaryPending: 'Summary pending',
  reportStatusSummaryProcessing: 'Summary processing',
  lessonGroupPlannedEmptyTitle: 'This lesson has not been completed yet.',
  lessonGroupPlannedEmptyDescription:
    'After the lesson is completed, transcript, AI summary, quiz, and mentor notes will appear here.',
  lessonGroupCompletedNoReportTitle: 'Lesson completed. Report is being prepared.',
  lessonGroupCompletedNoReportDescription:
    'The AI summary will be created once the transcript is ready.',
  lessonGroupReportReadyTitle: 'Lesson report is ready.',
  lessonGroupCancelledTitle: 'This lesson was cancelled',
  lessonGroupUpcomingSection: 'Upcoming / Planned',
  lessonGroupCompletedSection: 'Completed',
  lessonGroupCancelledSection: 'Cancelled',
  lessonGroupSidebarStudent: 'Student',
  lessonGroupSidebarMentor: 'Mentor',
  lessonGroupSidebarSubject: 'Subject / Service',
  lessonGroupTotalSessions: 'Total sessions',
  lessonGroupTotalCompletedTime: 'Total completed time',
  lessonGroupQuickActions: 'Quick actions',
  requestNewLesson: 'Request new lesson',
  viewMaterials: 'View materials',
  viewReportStatus: 'View report status',
  viewReport: 'View report',
  viewSessions: 'View Sessions',
  viewQuizResults: 'View quiz results',
  nextSteps: 'Next steps',
  lessonInfoTitle: 'Lesson details',
  lessonInfoSubject: 'Subject / Service',
  lessonInfoStudent: 'Student',
  lessonInfoMentor: 'Mentor',
  lessonInfoDate: 'Date',
  lessonInfoDuration: 'Duration',
  lessonInfoStatus: 'Status',
  reportStatusCardLesson: 'Lesson status',
  reportStatusCardAiSummary: 'AI summary',
  reportStatusCardQuiz: 'Quiz',
  reportStatusCardMentorNote: 'Mentor note',
  reportPlannedBannerTitle: 'This lesson has not been completed yet.',
  reportPlannedBannerDescription:
    'After the lesson is completed, transcript, AI summary, quiz, and mentor notes will appear here.',
  reportProcessingBannerTitle: 'Lesson completed. Report is being prepared.',
  reportProcessingBannerDescription: 'The AI summary will be created once the transcript is ready.',
  reportStatusCardTranscript: 'Transcript',
  reportStatusCardReview: 'Review',
  aiSummaryNotReadyPlannedTitle: 'Lesson summary is not ready yet',
  aiSummaryNotReadyPlannedDescription:
    'The AI summary will appear here after the lesson is completed and the transcript is ready.',
  aiSummaryProcessingTitle: 'Lesson completed, summary is processing',
  aiSummaryProcessingDescription: 'The AI summary will be generated once the transcript is ready.',
  aiSummaryFailedTitle: 'Lesson summary could not be created',
  aiSummaryFailedDescription:
    'The AI summary could not be prepared because the transcript was unavailable.',
  aiSummaryTopicsCovered: 'Topics covered in the lesson',
  aiSummaryStudentStrengths: 'Student strengths',
  aiSummaryPracticeAreas: 'Areas to practice',
  aiSummaryNextLessonSuggestions: 'Suggestions for the next lesson',
  quizNotAssignedTitle: 'No quiz assigned yet',
  quizNotAssignedDescription: 'It will appear here when the mentor creates a quiz.',
  quizAssignedTitle: 'Quiz assigned',
  quizAssignedWaitingDescription: 'Results will appear here when the student completes the quiz.',
  quizResultScore: 'Score: {{score}}/{{total}}',
  quizResultCompletionStatus: 'Completion status: Completed',
  quizResultCompletedAt: 'Completed on: {{date}}',
  mentorNoteEmpty: 'The mentor has not added a note for this lesson yet.',
  mentorNoteNoneYet: 'Mentor note not added yet.',
  rateLessonTitle: 'Rate this lesson',
  rateLessonDescription: 'Share your experience for this lesson.',
  submitRating: 'Submit rating',
  yourRatingTitle: 'Your rating',
  ratingAfterCompleted: 'Rating can be submitted after the lesson is completed.',
  ratingUnavailableApi: 'Lesson ratings will be available here soon.',
  participationLevel: 'Participation',
  understandingScore: 'Understanding',
  engagementScore: 'Engagement',
  knowledgeGapLabel: 'Knowledge gap',
  studentsGradeShort: 'Grade {{grade}}',
  lessonsJoinNotAllowed: 'You cannot join this session yet.',
  lessonsJoinFailed: 'Could not join the session. Please try again.',
  meetJoinActive: 'Join lesson',
  meetJoinPending: 'Link is being prepared',
  meetJoinPendingHint: 'The lesson link will be ready shortly.',
  meetJoinFailed: 'Link could not be created',
  meetJoinFailedHint: 'Please contact support.',
  meetJoinNotYet: 'Available at lesson time',
  meetJoinNoLink: 'No lesson link',
  meetProviderGoogle: 'Google Meet',
  meetRetryLink: 'Retry meeting link',
  meetRetrySuccess: 'Meeting link is ready',
  meetRetryPending: 'Meeting link is still being prepared',
  meetRetryFailed: 'Could not create meeting link',
  messages: 'Messages',
  wallet: 'Wallet',
  profile: 'Profile',
  notifications: 'Notifications',
  notificationsLoadError: 'Could not load notifications',
  notificationsEmpty: 'No notifications',
  markAllNotificationsRead: 'Mark all as read',
  notificationDefaultTitle: 'Notification',
  notificationNewMessageTitle: 'New message',
  notificationNewMessageBody: '{{name}} sent you a message.',
  availability: 'Availability',
  earnings: 'Earnings',
  welcome: 'Welcome',
  welcomeBackTitle: 'Welcome back',
  welcomeBackGreeting: 'Welcome back, {{name}}!',
  welcomeBackSubtitle: 'Sign in to continue learning',
  creditUnit: 'credit',
  linkedStudentNotFound: 'No linked student found.',
  quickActionJoinLesson: 'Join lesson',
  quickActionMyLessons: 'My lessons',
  quickActionMessages: 'Messages',
  quickActionFindMentor: 'Search Mentors',
  quickActionWallet: 'Wallet',
  quickActionChildProgress: 'Child progress',
  quickActionAvailability: 'Availability',
  quickActionEarnings: 'Earnings',
  quickActionListings: 'My listings',
  registerCardTitle: 'Create account',
  registerCardSubtitle: 'Choose your role and enter your details',
  forgotCardSubtitle: 'We will send a reset link to your email or phone.',
  upcomingLesson: 'Upcoming lesson',
  dashboardQuickActions: 'Quick actions',
  dashboardJoinLesson: 'Join lesson',
  dashboardViewDetails: 'View details',
  dashboardLessonTopic: 'Topic',
  dashboardGrade: 'Grade',
  dashboardAddCredits: 'Add credits',
  dashboardOpenSlots: 'Open',
  dashboardBookedSlots: 'Booked',
  dashboardEarningsToday: 'Today',
  dashboardEarningsWeek: 'Week',
  dashboardEarningsMonth: 'Month',
  dashboardNoScheduleToday: 'No sessions scheduled today',
  dashboardNoScheduleTodayHint: 'When you have lessons today, they will appear here.',
  todaySchedule: "Today's schedule",
  linkedStudents: 'Linked student',
  walletBalance: 'Wallet balance',
  lessonsOverview: 'Lessons overview',
  aiReport: 'AI report',
  availabilityStatus: 'Availability status',
  earningsPlaceholder: 'Earnings summary',
  earningsPageDescription: 'Your mentor wallet balances and payout-ready amount.',
  earningsLoadError: 'Could not load earnings',
  earningsAvailablePayout: 'Available for payout',
  earningsPending: 'Pending',
  earningsTotalEarned: 'Total earned',
  earningsTotalPaidOut: 'Total paid out',
  earningsTotalBalance: 'Total balance',
  earningsTotalBonuses: 'Bonuses',
  earningsTotalReversed: 'Reversed',
  mentorWalletPreviewHint: 'View earnings and payouts',
  mentorWalletPreviewError: 'Unable to load wallet',
  mentorWalletPageDescription: 'Your earnings and payout details.',
  mentorWalletPendingInline: 'Pending',
  mentorWalletPayoutActionsTitle: 'Payout actions',
  mentorWalletPayoutActionsHint: 'Request a payout or manage your bank details.',
  mentorWalletRequestPayout: 'Request payout',
  mentorWalletManagePayoutMethods: 'Manage payout methods',
  mentorWalletPayoutRequestsTitle: 'Payout requests',
  mentorWalletTransactionsTitle: 'Transactions',
  mentorWalletPayoutRequestsLoadError: 'Could not load payout requests',
  mentorWalletTransactionsLoadError: 'Could not load transactions',
  mentorWalletNoPayoutRequestsTitle: 'No payout requests yet',
  mentorWalletNoPayoutRequestsBody: 'Your payout requests will appear here.',
  mentorWalletNoTransactionsTitle: 'No wallet activity yet',
  mentorWalletNoTransactionsBody: 'Your earnings and payout activity will appear here.',
  mentorWalletPayoutMethodsTitle: 'Payout methods',
  mentorWalletPayoutMethodsHint: 'Add and manage your bank transfer details.',
  mentorWalletPayoutMethodsPageDescription: 'Bank transfer details used for payouts.',
  mentorWalletPayoutMethodsLoadError: 'Could not load payout methods',
  mentorWalletNoPayoutMethodsTitle: 'No payout method added yet',
  mentorWalletNoPayoutMethodsBody: 'Add a bank transfer method to request payouts.',
  mentorWalletAddPayoutMethod: 'Add payout method',
  mentorWalletEditPayoutMethodTitle: 'Edit payout method',
  mentorWalletAddPayoutMethodTitle: 'Add payout method',
  mentorWalletPayoutMethodFormDescription: 'Provide your bank transfer information.',
  mentorWalletBankTransfer: 'Bank transfer',
  mentorWalletDefaultBadge: 'Default',
  mentorWalletSetDefault: 'Set default',
  mentorWalletDeactivate: 'Deactivate',
  mentorWalletNoPayoutMethodBlocker: 'Add an active payout method before requesting a payout.',
  mentorWalletPayoutMethodLabel: 'Payout method',
  mentorWalletAmountLabel: 'Amount',
  mentorWalletInvalidPayoutAmount:
    'Enter an amount greater than 0 and not exceeding your available balance.',
  mentorWalletNoActiveMethod: 'No active payout method found.',
  mentorWalletSubmitPayoutRequest: 'Submit payout request',
  mentorWalletRequestedAtLabel: 'Requested',
  mentorWalletPaidAtLabel: 'Paid',
  mentorWalletFailureReasonLabel: 'Failure reason',
  mentorWalletAccountHolderName: 'Account holder name',
  mentorWalletIban: 'IBAN',
  mentorWalletBankName: 'Bank name',
  mentorWalletBranchNameOptional: 'Branch name (optional)',
  mentorWalletAccountNumberOptional: 'Account number (optional)',
  mentorWalletFieldRequired: 'This field is required.',
  mentorWalletLoadErrorTitle: 'Could not load wallet',
  mentorWalletLoadErrorBody: 'Please try again.',
  loadMore: 'Load more',
  edit: 'Edit',
  save: 'Save',
  loading: 'Loading…',
  errorTitle: 'Something went wrong',
  retry: 'Try again',
  empty: 'No records yet',
  suspendedTitle: 'Account unavailable',
  suspendedBody: 'Your account is suspended. Please contact support.',
  searchMentors: 'Search Mentors',
  findMentor: 'Search Mentors',
  searchPlaceholder: 'Search mentor, subject or grade level…',
  noMentorsFound: 'No mentors found.',
  noMentorsHint: 'Try changing your search or filters.',
  mentorsLoadError: 'Could not load mentors.',
  mentorProfileLoadError: 'Could not load mentor profile.',
  listingLoadError: 'Could not load listing.',
  favouriteUpdateError: 'Could not update favourite.',
  verifiedMentor: 'Certified mentor',
  viewServices: 'View services',
  viewMentor: 'View mentor',
  services: 'Services',
  aboutMentor: 'About',
  noActiveServices: 'This mentor has no active services right now.',
  priceDuringBooking: 'Price is shown when booking',
  bookLesson: 'Book lesson',
  continueToBooking: 'Continue to booking',
  addToFavourites: 'Add to favourites',
  askParentToBook: 'Ask parent to book',
  studentBookingNote:
    'Only parents can book lessons. You can add this mentor to favourites for your parent to review.',
  studentContactNote:
    'Only parents can contact mentors directly. Please ask your parent to reach out.',
  contactMentorWelcomeMessage: 'Hello, I would like to contact you regarding your services.',
  studentBookingBlocked:
    'Only parents can book lessons. Add this mentor to favourites so your parent can see them.',
  favourites: 'Favorites',
  favouritesEmpty: 'You have no favourite mentors yet.',
  favouritesTabMentors: 'Mentors',
  favouritesTabListings: 'Listings',
  noSavedListings: 'No saved listings yet.',
  savedListingsHint: 'Save lesson listings to compare them later before booking.',
  byMentor: 'by {{name}}',
  savedLessonListing: 'Saved lesson listing',
  viewListing: 'View listing',
  remove: 'Remove',
  removeFromFavourites: 'Remove from favourites',
  studentFavouriteMentors: 'Student favourite mentors',
  listingDetail: 'Service details',
  howManyLessons: 'How many lessons would you like to book?',
  lessonHourNote: 'Each lesson is 1 hour.',
  customLessonCount: 'Custom',
  availableSlots: 'Available times',
  slotsLoading: 'Loading available times…',
  slotsEmpty: 'No available times in this period.',
  slotsLoadError: 'Could not load available times.',
  bookingSummary: 'Booking summary',
  nextStep: 'Next step',
  continueToPayment: 'Continue to payment',
  paymentPlaceholder: 'Payment flow will be connected in a later step.',
  checkoutTitle: 'Confirm booking',
  checkoutSubtitle: 'Internal credit checkout (no real payment gateway).',
  checkoutCreditsTitle: 'Credit transaction',
  checkoutInitialBalance: 'Current balance',
  checkoutPackage: 'Package credits',
  checkoutConsume: 'Credits to use',
  checkoutFinalBalance: 'Balance after',
  checkoutDummyNotice: 'This step uses internal credits. Card payments will be added later.',
  checkoutMissingBooking: 'Booking not found',
  checkoutFailed: 'Checkout could not be completed',
  confirmBooking: 'Confirm booking',
  bookingConfirmed: 'Booking confirmed',
  bookingCreateFailed: 'Could not create booking',
  goToDashboard: 'Go to dashboard',
  viewLessons: 'View my classes',
  selectedTimes: 'Selected times',
  selectStudent: 'Select student',
  selectStudentHint: 'Who is this booking for?',
  creditsUnit: 'credits',
  processing: 'Processing…',
  bookingStep: 'Step',
  selectSlotsHint: 'Please select as many time slots as the number of lessons.',
  clearFilters: 'Clear filters',
  activeListings: 'active',
  views: 'views',
  bookings: 'bookings',
  filterMathematics: 'Mathematics',
  filterPhysics: 'Physics',
  filterHighSchool: 'High school',
  filterOneToOne: '1:1',
  filterGroup: 'Group',
  filtersAriaLabel: 'Search filters',
  clearSearch: 'Clear search',
  mentorsFound: '{{count}} mentors found',
  gradeLabel: 'Grades',
  servicesLabel: 'Services',
  expertIn: 'Expert in {{subjects}}',
  ratingNotAvailable: 'No reviews yet',
  viewListingDetails: 'View details',
  invalidBookingLink: 'Invalid booking link.',
  bookingSummaryMentor: 'Mentor',
  bookingSummaryService: 'Service',
  bookingSummaryLessonCount: 'Lessons',
  bookingSummaryEstimated: 'Estimated total',
  slotNoLongerAvailable:
    'One of the selected times is no longer available. Go back and pick times again.',
  parentOnlyBooking: 'Only parents can book lessons.',
  accessRestricted: 'Access restricted',
  studentBookingRestrictedBody:
    'Students cannot book lessons directly. Please ask your parent to book this lesson.',
  ok: 'OK',
  studentFavouritesTitle: "{{name}}'s favourite mentors",
  studentFavouritesEmpty: 'No favourite mentors yet.',
  studentFavouritesLoadError: 'Could not load student favourites.',
  postListing: 'Listings',
  myPostings: 'My Listings',
  createNewListing: 'New Listing',
  createListingTitle: 'Create New Listing',
  createListingDescription: 'Add a lesson listing students and parents can discover.',
  createListingSubmit: 'Create Listing',
  editListingTitle: 'Edit Listing',
  editListingDescription: 'Update your lesson listing details.',
  saveListingChanges: 'Save Changes',
  listingsEmpty: "You haven't created any lesson listings yet.",
  listingsLoadError: 'Failed to load listings.',
  listingCreated: 'Listing created successfully.',
  listingUpdated: 'Listing updated successfully.',
  listingCreateError: 'Failed to create listing.',
  listingUpdateError: 'Failed to update listing.',
  listingStatusUpdateError: 'Failed to update listing status.',
  listingNotFound: 'Listing not found.',
  refreshList: 'Refresh',
  listingViews: 'Views',
  listingBookings: 'Bookings',
  editListing: 'Edit',
  manageListings: 'Manage your lesson postings',
  goToMyPostings: 'Go to My Listings',
  noAccountPrompt: "Don't have an account?",
  signUpLink: 'Sign up',
  notProvided: 'Not provided',
  noPhone: 'No phone added',
  noLinkedChild: 'No linked student yet',
  editProfile: 'Edit profile',
  saveProfile: 'Save',
  cancel: 'Cancel',
  back: 'Back',
  firstName: 'First name',
  lastName: 'Last name',
  phone: 'Phone',
  email: 'Email',
  role: 'Role',
  bio: 'Short bio',
  university: 'University',
  verificationStatus: 'Verification status',
  childName: 'Student name',
  childEmail: 'Student email',
  dateOfBirth: 'Date of birth',
  ageYears: 'Age',
  parentInfo: 'Parent info',
  profilePhotoPlaceholder: 'Profile photo',
  profilePhotoHint: 'Upload a file first, then we fetch a short-lived link to display it.',
  profilePhotoEditHint: 'You can update your photo here or in the mobile app.',
  changePhoto: 'Choose photo',
  photoUploadOk: 'Profile photo updated',
  photoUploadFailed: 'Photo upload failed',
  photoTooLarge: 'File must be 5 MB or less',
  logoutConfirmTitle: 'Log out?',
  logoutConfirmBody: 'You will be signed out and redirected to the login page.',
  logoutConfirmAction: 'Log out',
  unsavedTitle: 'Unsaved changes',
  unsavedBody: 'Leave this page? Your changes will be lost.',
  stayOnPage: 'Stay on page',
  leavePage: 'Leave',
  profileUpdated: 'Profile updated',
  profileLoadError: 'Could not load profile',
  profileSaveError: 'Save failed',
  roleParent: 'Parent',
  roleMentor: 'Mentor',
  roleStudent: 'Student',
  verificationNotStarted: 'Not started',
  verificationPending: 'Pending',
  verificationVerified: 'Verified',
  verificationFailed: 'Failed',
  loginFailed: 'Sign in failed',
  verifyTitle: 'Verify your account',
  verifyEmailSubtitle: 'Enter the 6-digit code sent to your email:',
  verifyPhoneSubtitle: 'Enter the 6-digit code sent to your phone:',
  verificationCode: 'Verification code',
  verifyAndContinue: 'Verify & continue',
  verifyResendPrompt: "Didn't receive it?",
  verifyResendNow: 'Resend now',
  verifyResendIn: 'Resend in {{seconds}}s',
  verifyCodeIncomplete: 'Enter the full 6-digit code',
  verifyTargetMissing: 'Verification target is missing',
  verifySuccess: 'Verified successfully',
  verifyFailed: 'Verification failed',
  verifyResent: 'A new code has been sent',
  verifyResendFailed: 'Could not resend code',
  verifyFlowUnknown: 'Could not determine the next verification step',
  verifyContactSupportTitle: 'Contact support',
  verifyContactSupportBody:
    'Your account needs help from support before you can sign in. Please contact Mentora support.',
  devOtpHint: 'Development: use fixed OTP {{code}}',
  forgotPasswordFailed: 'Could not start password reset',
  resetPasswordTitle: 'Set a new password',
  resetPasswordSubtitle: 'Choose a strong password for your account.',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  resetPasswordSubmit: 'Update password',
  resetPasswordSuccess: 'Password updated. You can sign in now.',
  resetPasswordSuccessTitle: 'Password updated',
  resetPasswordFailed: 'Could not update password',
  resetVerifyTitle: 'Confirm your identity',
  resetVerifySubtitle: 'Enter the verification code sent to',
  resetCodeRequired: 'Enter the code you received to continue',
  showPassword: 'Show password',
  hidePassword: 'Hide password',
  education: 'Education',
  educationPrimary: 'Primary School',
  educationMiddle: 'Middle School',
  educationHigh: 'High School',
  subjectsAndGrades: 'Subjects and Supported Grades',
  examPreparation: 'Exam Preparation',
  noUniversitySelected: 'No university selected yet.',
  noSubjectsAdded: 'No subjects added yet.',
  noExamSubjectsAdded: 'No exam preparation subjects added yet.',
  attendanceStatus: 'Attendance status',
  currentlyAttending: 'Currently attending',
  graduated: 'Graduated',
  universitySearchPlaceholder: 'Search university…',
  universitySearchEmpty: 'No universities found.',
  universitySearchError: 'Could not load universities.',
  clearSelection: 'Clear',
  addProficiency: 'Add',
  removeSubject: 'Remove subject',
  removeGrade: 'Remove grade',
  selectEducationLevel: 'Education level',
  selectGrade: 'Grade',
  selectSubject: 'Subject',
  selectExamTrack: 'Exam track',
  selectExamSubject: 'Exam subject',
  addExamSubject: 'Add exam subject',
  gradesLabel: 'Grades',
  gradesRange: 'Grades {{range}}',
  moreProficiencies: '+{{count}} more',
  filterUniversity: 'University',
  filterEducationLevel: 'Education level',
  filterExactGrade: 'Grade',
  filterSubject: 'Subject',
  filterExamPrep: 'Exam preparation',
  filterMinRating: 'Min. rating',
  filterRatingAny: 'Any',
  filterQuickTags: 'Quick tags',
  searchFilters: 'Filters',
  searchFiltersHint: 'Refine results by university, subject, and more',
  selectEducationLevelFirst: 'Select education level first',
  activeFilters: 'Active filters',
  clearAllFilters: 'Clear all',
  subjectsLoadError: 'Could not load subjects.',
  examSubjectsLoadError: 'Could not load exam subjects.',
  structuredListingSubject: '{{subject}} — Grades {{grades}}',
  profileErrorInvalidUniversity: 'The selected university is not valid. Choose another university.',
  profileErrorInvalidSubjectGrade: 'One or more subject and grade combinations are not valid.',
  profileErrorInvalidExamSubject: 'One or more exam preparation subjects are not valid.',
  noDate: 'No date',
  lessonDefaultTitle: 'Lesson',
  withParticipant: 'with {{name}}',
  minutesUnit: 'min',
  messageButton: 'Send Message',
  detailButton: 'Detail',
  lessonReportButton: 'Lesson report',
  backToLessons: 'Back to lessons',
  invalidSession: 'Invalid session',
  invalidLesson: 'Invalid lesson',
  lessonDetailTitle: 'Lesson detail',
  lessonDetailLoadError: 'Could not load lesson detail',
  lessonReportTitle: 'Lesson report',
  lessonReportLoadError: 'Could not load lesson report',
  lessonSessionsLoadError: 'Could not load sessions',
  noPastSessions: 'No past sessions',
  noPastSessionsDescription: 'There are no completed sessions for this group yet.',
  topicNotSpecified: 'No topic specified',
  mentorNote: 'Mentor note',
  mentorNotePlaceholder: 'Write your session notes…',
  saveNote: 'Save note',
  updateNote: 'Update note',
  noteSaved: 'Note saved',
  noteSaveFailed: 'Could not save note',
  recordingNotice:
    'This lesson may be recorded and transcribed to generate summaries and quizzes after the lesson. You will be asked for recording consent when you join.',
  endLesson: 'End lesson',
  endLessonConfirm: 'Are you sure you want to end this lesson? This action cannot be undone.',
  endLessonSuccess: 'Lesson marked as completed.',
  endLessonSummarySuccess: 'Lesson completed and AI summary generated.',
  endLessonFailed: 'Could not end lesson.',
  consentSaveFailed: 'Could not save recording consent.',
  recordingConsentTitle: 'Lesson recording',
  recordingConsentBody:
    'This lesson will be recorded and transcribed by our AI note-taker to generate automated summaries and quizzes. Do you consent to being recorded?',
  decline: 'Decline',
  accept: 'I agree',
  sessionStatusScheduled: 'Scheduled',
  sessionStatusCompleted: 'Completed',
  sessionStatusCancelled: 'Cancelled',
  sessionStatusRescheduled: 'Rescheduled',
  sessionStatusInProgress: 'In progress',
  // Parent-friendly aliases used on lesson cards / badges
  sessionStatusPlanned: 'Scheduled',
  listingStatusActive: 'Active',
  listingStatusInactive: 'Inactive',
  listingFormatGroup: 'Groups',
  listingFormatOneToOne: '1:1',
  listingLessonFormat: 'Lesson format',
  listingGradePrimary: 'Primary',
  listingGradeMiddleSchool: 'Middle School',
  listingGradeHighSchool: 'High School',
  listingSubjectMathematics: 'Mathematics',
  listingSubjectPhysics: 'Physics',
  listingSubjectChemistry: 'Chemistry',
  listingSubjectBiology: 'Biology',
  listingSubjectEnglish: 'English',
  listingSubjectComputerScience: 'Computer Science',
  listingSubjectHistory: 'History',
  listingSubjectEconomics: 'Economics',
  transcriptStatusLabel: 'Transcript status',
  transcriptReadyAiAvailable: 'Transcript is ready. AI features are available.',
  transcriptInProgress: 'Transcript is being processed.',
  transcriptScheduled: 'Transcript capture is scheduled.',
  transcriptFailedDetail: 'Transcript capture failed. AI summary and quiz may be unavailable.',
  transcriptFailed: 'Transcript is unavailable for this lesson.',
  transcriptNotScheduled: 'Transcript capture is not scheduled for this session.',
  aiContentBeingPrepared: 'AI content is being prepared.',
  lessonTranscript: 'Lesson Transcript',
  transcriptLoading: 'Loading transcript…',
  transcriptNotReady: 'The transcript is not ready yet. Please check back later.',
  transcriptTextUnavailable: 'Transcript text is not available yet.',
  viewFullTranscript: 'View full transcript',
  fullSessionTranscript: 'Full session transcript',
  aiLessonSummary: 'AI Lesson Summary',
  loadingAiSummary: 'Loading AI summary…',
  aiSummaryLoadError: 'Could not load AI summary.',
  aiSummaryUnavailable: 'AI summary is not available yet.',
  aiSummaryTranscriptFailed:
    'AI summary could not be generated because the transcript is unavailable.',
  aiSummaryWaitingTranscript: 'AI summary will appear after the lesson transcript is ready.',
  aiSummaryGenerating: 'AI is generating your summary. Check back shortly.',
  aiSummaryEmpty: 'AI lesson summary will appear here.',
  generateAiSummary: 'Generate AI Summary',
  generatingSummary: 'Generating summary…',
  generateAiSummaryError: 'Could not generate summary. Please try again.',
  aiSummaryGenerated: 'AI summary generated successfully',
  aiSummaryUpdated: 'Summary updated successfully',
  aiSummarySaveError: 'Could not save summary',
  editSummary: 'Edit Summary',
  aiQuiz: 'AI Quiz',
  loadingQuiz: 'Loading quiz…',
  quizLoadError: 'Could not load quiz.',
  quizNotGenerated: 'No quiz has been generated yet.',
  generateQuiz: 'Generate Quiz',
  generatingQuiz: 'Generating quiz…',
  generateQuizError: 'Could not generate quiz. Please try again.',
  quizGenerated: 'Quiz generated successfully',
  publishQuizTitle: 'Publish Quiz?',
  publishQuizBody: 'After publishing, the student will be able to open and solve this quiz.',
  publishQuiz: 'Publish',
  quizPublished: 'Quiz published to student',
  publishQuizError: 'Could not publish quiz',
  studentQuizResult: 'Student Quiz Result',
  score: 'Score',
  percentage: 'Percentage',
  quizNotAssigned: 'No quiz has been assigned yet.',
  quizCompleted: 'You have completed this quiz.',
  viewResult: 'View Result',
  quizAssignedDescription: 'Your mentor assigned a quiz from this lesson.',
  startQuiz: 'Start Quiz',
  legacyQuizAnswers: 'Legacy quiz answers',
  questionLabel: 'Question {{number}}',
  answerLabel: 'Answer',
  correctLabel: 'correct',
  incorrectLabel: 'incorrect',
  legacyQuizAnswersPending:
    'Quiz questions are available; student answers have not been recorded yet.',
  noLegacyQuizAnswers: 'No legacy quiz answers yet.',
  legacyQuizzes: 'Legacy quizzes',
  noScore: 'No score',
  quizPreviewTitle: 'Quiz Preview',
  quizEditTitle: 'Edit Quiz',
  quizResultTitle: 'Quiz Result',
  quizTakeTitle: 'Lesson Quiz',
  quizNotAvailable: 'Quiz not available',
  resultNotAvailable: 'Result not available',
  submitQuizTitle: 'Submit Quiz?',
  questionProgress: 'Question {{current}} of {{total}}',
  messagesPageDescription: 'Chat with your mentors, students, and parents about a lesson.',
  messagesLoginRequired: 'Sign in to view messages.',
  messagesLoadError: 'Could not load messages',
  messagesChatFallback: 'Chat',
  messagesLessonThreadPrefix: 'Lesson',
  messagesEmptyThreads: 'No conversations yet.',
  messagesSelectThread: 'Select a conversation.',
  messagesWritePlaceholder: 'Write a message…',
  messagesSend: 'Send',
  messagesParentStartRequired:
    'This conversation has not started yet. Ask the parent to send the first message from their account.',
  calendarPrevMonth: 'Previous month',
  calendarNextMonth: 'Next month',
  lessonsCalendarSessionsThisMonth: '{{count}} days with lessons this month',
  availabilityPageDescription: 'Manage your weekly working hours and date exceptions.',
  availabilityTabWeeklyHours: 'Weekly hours',
  availabilityTabDateOverrides: 'Date exceptions',
  availabilitySameHoursAllDays: 'Same hours for all days',
  availabilityAllDays: 'All days',
  availabilityAddRange: 'Add range',
  availabilitySelectTime: 'Select time',
  availabilityDayUnavailable: 'Unavailable this day',
  availabilityStartTime: 'Start',
  availabilityEndTime: 'End',
  availabilityCustomHours: 'Custom hours',
  availabilityUnavailable: 'Unavailable',
  availabilityDateOverridesHeader: 'Date exceptions',
  availabilityLoadError: 'Could not load availability',
  availabilitySaveSuccess: 'Availability saved.',
  availabilitySaveError: 'Save failed. Your mentor account must be active and verified.',
  availabilityStartBeforeEnd: 'Start time must be before end time.',
  availabilityTimeOverlap: 'This time range overlaps an existing range.',
  apply: 'Apply',
  bookingStepSelectDate: '1. Select a date',
  bookingStepSelectTime: '2. Select a time',
  validationFirstNameRequired: 'First name is required',
  validationLastNameRequired: 'Last name is required',
  validationPhoneInvalid: 'Enter a valid phone number',
  validationBioMaxLength: 'Maximum 500 characters',
  validationDateOfBirthPast: 'Choose a date in the past',
  validationDateOfBirthRequired: 'Date of birth is required',
  materialsMentorTitle: 'Materials & Assignments',
  materialsMentorDescription: 'Upload course resources and assignments for your students.',
  materialsStudentTitle: 'Assignments & Resources',
  materialsStudentDescription: 'View materials assigned by your mentors.',
  materialsParentTitle: "Child's Assignments",
  materialsParentDescription: 'View materials and assignments assigned to your child.',
  materialsParentNoStudentDescription:
    'Link a student to your account to see their assignments and resources.',
  materialsLoadError: 'Could not load materials',
  materialsEmptyTitle: 'No materials yet',
  materialsEmptyMentorDescription:
    'Create your first assignment or course resource to share with students.',
  materialsEmptyStudentDescription: 'Materials and assignments from your mentors will appear here.',
  materialsEmptyParentDescription: 'Assignments and resources from mentors will appear here.',
  materialTabAll: 'All',
  materialTabAssignments: 'Assignments',
  materialTabResources: 'Course Resources',
  materialCreate: 'New Material',
  materialCreateTitle: 'Upload Material',
  materialCreateDescription: 'Share a PDF assignment or course resource with selected students.',
  materialEditTitle: 'Edit Material',
  materialEditDescription: 'Update assignment details, due date, or assigned students.',
  materialEdit: 'Edit',
  materialViewDetails: 'View details',
  materialArchive: 'Archive',
  materialBackToList: 'Back to materials',
  materialBackToDetail: 'Back to material',
  materialFieldTitle: 'Title',
  materialFieldDescription: 'Description (optional)',
  materialFieldType: 'Type',
  materialFieldDueDate: 'Due date',
  materialFieldStatus: 'Status',
  materialTypeAssignment: 'Assignment',
  materialTypeCourseResource: 'Course Resource',
  materialTitlePlaceholder: 'e.g. Chapter 3 worksheet',
  materialDescriptionPlaceholder: 'Brief description…',
  materialAssignStudents: 'Assign to students',
  materialNoStudentsAvailable:
    'No students available. Active lessons are required before assigning materials.',
  materialUploadPdf: 'Upload PDF',
  materialPdfMaxSize: 'PDF only. Max {{size}} MB.',
  materialDue: 'Due',
  materialCreated: 'Created',
  materialStudents: 'students',
  materialSubmittedCount: 'Submitted: {{submitted}} / {{total}}',
  materialMissingCount: 'Missing: {{count}}',
  materialCourseResourceHint: 'No submission required',
  materialNoSubmissionRequired: 'No submission required',
  materialNoFile: 'No file',
  materialStatActive: 'Active Materials',
  materialStatAssignments: 'Assignments',
  materialStatResources: 'Course Resources',
  materialStatPending: 'Pending Submissions',
  materialStatLate: 'Late Submissions',
  materialSearchPlaceholder: 'Search by title',
  materialFilterTypeLabel: 'Type',
  materialFilterStatusLabel: 'Status',
  materialTypeAll: 'All',
  materialTabAllCount: 'All ({{count}})',
  materialTabAssignmentsCount: 'Assignments ({{count}})',
  materialTabResourcesCount: 'Course Resources ({{count}})',
  materialArchiveConfirmTitle: 'Archive this material?',
  materialArchiveConfirmBody:
    'Students will no longer see it as active, but existing submissions will remain available.',
  materialArchiveConfirmAction: 'Archive',
  materialSelectedStudents: 'Selected: {{count}} students',
  materialSelectAll: 'Select all',
  materialClearSelection: 'Clear selection',
  materialSearchStudents: 'Search students',
  materialPdfDropHint: 'Drag and drop a PDF here, or choose file',
  materialPdfConstraints: 'PDF only · Max 10 MB',
  materialRemoveFile: 'Remove',
  materialUploadAction: 'Upload Material',
  materialSaveChanges: 'Save Changes',
  materialAssignedToCount: 'Assigned to {{count}} students',
  materialSubmittedOf: 'Submitted {{submitted}} / {{total}}',
  materialMissingLabel: 'Missing {{count}}',
  materialHeaderActive: 'Active',
  materialFilterSubmittedCount: 'Submitted ({{count}})',
  materialFilterNotSubmittedCount: 'Not submitted ({{count}})',
  materialFilterLateCount: 'Late ({{count}})',
  materialFilterAllCount: 'All ({{count}})',
  earningsAndPayouts: 'Earnings & Payouts',
  viewPublicProfile: 'View Public Profile',
  profileCompletionLabel: 'Profile completion: {{percent}}%',
  profileMenuProfile: 'Profile',
  profileMenuListings: 'My Listings',
  profileMenuAvailability: 'Availability',
  profileMenuEarnings: 'Earnings',
  profileMenuNotifications: 'Notifications',
  profileMenuLogout: 'Log out',
  profileCurrentApproved: 'Current profile: Approved',
  profilePendingEditsWaiting: 'Pending edits: Waiting for review',
  profileApprovedVisibleWhileReview:
    'Your approved profile is still visible while your latest edits are reviewed.',
  profileApprovedAndVisible: 'Your public profile is approved and visible.',
  profileSectionPersonal: 'Personal Information',
  profileSectionPublic: 'Public Mentor Profile',
  profileSectionEarnings: 'Earnings & Payouts',
  profileSectionPreferences: 'Account Preferences',
  profileSectionSecurity: 'Security',
  profileChecklistTitle: 'Complete your profile',
  profileChecklistVerified: 'Identity verified',
  profileChecklistEducation: 'Education added',
  profileChecklistSubjects: 'Subjects selected',
  profileChecklistBio: 'Bio added',
  profileChecklistListing: 'Listing created',
  profileChecklistAvailability: 'Availability set',
  profilePrefsLanguageHint: 'Language and theme can be changed from the top bar.',
  materialCourseResourceDetailHint: 'This is a course resource. No student submission is required.',
  materialAssignedStudents: 'Assigned students',
  materialSubmissionTable: 'Submission status',
  materialSubmissionStatus: 'Submission status',
  materialYourSubmission: 'Your submission',
  materialUploadSubmissionHint: 'Upload your completed assignment as PDF',
  materialPastDueWarning:
    'This assignment is past the due date. Your submission may be marked as late.',
  materialNoSubmissionYet: 'No submission yet',
  materialNoSubmissions: 'No submissions yet',
  materialSubmittedAt: 'Submitted at',
  materialShowingForChild: 'Showing materials for {{name}}',
  materialColTitle: 'Title',
  materialColType: 'Type',
  materialColAssigned: 'Assigned',
  materialColDueDate: 'Due date',
  materialColSubmissions: 'Submissions',
  materialColCreated: 'Created',
  materialColStatus: 'Status',
  materialColActions: 'Actions',
  materialColStudent: 'Student',
  materialColParent: 'Parent',
  materialColSubmittedAt: 'Submitted at',
  materialColFile: 'File',
  materialFilterAll: 'All',
  materialFilterSubmitted: 'Submitted',
  materialFilterNotSubmitted: 'Not submitted',
  materialFilterLate: 'Late',
  materialStatusActive: 'Active',
  materialStatusArchived: 'Archived',
  materialStatusNotSubmitted: 'Not submitted',
  materialStatusSubmitted: 'Submitted',
  materialStatusLate: 'Late',
  materialStatusResubmitted: 'Resubmitted',
  materialStatusDueTomorrow: 'Due tomorrow',
  materialStatusOverdue: 'Overdue',
  materialValidationTitleRequired: 'Please enter a title.',
  materialValidationTypeRequired: 'Please select assignment or course resource.',
  materialValidationPdfRequired: 'Please upload a PDF file.',
  materialValidationPdfOnly: 'Only PDF files are allowed.',
  materialValidationStudentsRequired: 'Please select at least one student.',
  materialValidationDueDateRequired: 'Please select a due date for this assignment.',
  materialValidationFileTooLarge: 'File is too large.',
  materialCreatedSuccess: 'Material created successfully.',
  materialUpdatedSuccess: 'Material updated successfully.',
  materialArchivedSuccess: 'Material archived.',
  materialArchiveFailed: 'Failed to archive material.',
  materialCreateFailed: 'Failed to create material.',
  materialUpdateFailed: 'Failed to update material.',
  materialSubmissionSuccess: 'Assignment submitted successfully.',
  materialSubmissionFailed: 'Submission failed.',
  materialDueDateChangeTitle: 'Change due date?',
  materialDueDateChangeMessage:
    'Changing the due date will update reminder notifications for students and parents.',
  openPdf: 'Open PDF',
  downloadPdf: 'Download PDF',
  openTeacherPdf: 'Open teacher PDF',
  downloadTeacherPdf: 'Download teacher PDF',
  openSubmittedPdf: 'Open submitted PDF',
  downloadSubmittedPdf: 'Download submitted PDF',
  materialPdfUnavailable: 'PDF link is unavailable.',
  materialColChild: 'Child',
  submitAssignment: 'Submit Assignment',
  reuploadSubmission: 'Re-upload Submission',
  notificationOpenThread: 'Open conversation →',
  notificationOpenAssignment: 'Open assignment →',
  notificationAssignmentReminderTitle: 'Assignment reminder',
  notificationParentReminderTitle: 'Reminder',
  notificationMissingSubmissionsTitle: 'Missing submissions',
  notificationAssignmentDue3DaysStudent: 'Assignment reminder: "{{title}}" is due in 3 days.',
  notificationAssignmentDue1DayStudent: 'Assignment reminder: "{{title}}" is due tomorrow.',
  notificationAssignmentDue3DaysParent:
    'Reminder: Your child has an assignment "{{title}}" due in 3 days.',
  notificationAssignmentDue1DayParent:
    'Reminder: Your child has an assignment "{{title}}" due tomorrow.',
  notificationAssignmentMissingParent: 'Your child has not submitted the assignment "{{title}}".',
  notificationAssignmentMissingMentor: '{{count}} students have not submitted {{title}}',
  // Admin dashboard
  adminPanelTitle: 'Admin Panel',
  adminMenuAria: 'Admin menu',
  adminForbiddenTitle: 'Access denied',
  adminForbiddenBody: 'You do not have permission to access the admin dashboard.',
  adminGoHome: 'Go to home',
  adminNavDashboard: 'Dashboard',
  adminNavVerifications: 'Mentor Verifications',
  adminNavProfiles: 'Mentor Profiles',
  adminNavListings: 'Listings',
  adminNavMedia: 'Media',
  adminNavReviews: 'Reviews',
  adminNavSuccessStories: 'Success Stories',
  adminNavReports: 'Reports',
  adminNavUsers: 'Users',
  adminNavAuditLogs: 'Audit Logs',
  adminDashboardSubtitle: 'Operational overview',
  adminDashboardLoadError: 'Could not load dashboard stats.',
  adminStatTotalUsers: 'Total users',
  adminStatMentors: 'Mentors',
  adminStatSuspended: 'Suspended users',
  adminStatPendingVerifications: 'Pending verifications',
  adminStatPendingProfiles: 'Pending profile reviews',
  adminStatProfileRevisions: 'Pending revisions',
  adminStatHiddenProfiles: 'Hidden profiles',
  adminStatPendingListings: 'Pending listings',
  adminStatHiddenListings: 'Hidden listings',
  adminVerificationsSubtitle: 'Review mentor identity and student verification',
  adminVerificationsLoadError: 'Could not load verifications.',
  adminVerificationsEmpty: 'No pending mentor verifications.',
  adminColStudentVerification: 'Student verification',
  adminColIdentityVerification: 'Identity verification',
  adminColAccessStatus: 'Access status',
  adminColSubmitted: 'Submitted',
  adminColActions: 'Actions',
  adminMoreActions: 'More actions',
  adminColModerationStatus: 'Moderation',
  adminColPendingRevision: 'Pending revision',
  adminColMentor: 'Mentor',
  adminColListing: 'Listing',
  adminColLessonFormat: 'Format',
  adminColAvailability: 'Availability',
  adminColName: 'Name',
  adminColAccountStatus: 'Account status',
  adminColCreated: 'Created',
  adminColReviewed: 'Reviewed',
  adminView: 'View',
  adminApprove: 'Approve',
  adminReject: 'Reject',
  adminHide: 'Hide',
  adminRestore: 'Restore',
  adminRequestChanges: 'Request changes',
  adminReasonPlaceholder: 'Enter a reason…',
  adminPageOf: 'Page {{page}} of {{total}}',
  adminPrevPage: 'Previous',
  adminNextPage: 'Next',
  adminActionApproved: 'Approved successfully.',
  adminActionRejected: 'Rejected successfully.',
  adminActionSaved: 'Changes saved.',
  adminActionRestored: 'Restored successfully.',
  adminActionFailed: 'Action failed. Please try again.',
  adminVerificationLoadError: 'Could not load verification details.',
  adminMentorInfo: 'Mentor information',
  adminUploadedDocuments: 'Uploaded documents',
  adminNoDocuments: 'No documents uploaded.',
  adminViewDocument: 'View document',
  adminApproveVerificationTitle: 'Approve verification?',
  adminApproveVerificationBody:
    'This mentor will gain full platform access if requirements are met.',
  adminRejectVerificationTitle: 'Reject verification',
  adminProfilesSubtitle: 'Review initial profiles and pending revisions',
  adminProfilesLoadError: 'Could not load mentor profiles.',
  adminProfilesEmpty: 'No mentor profiles match your filters.',
  adminProfileLoadError: 'Could not load mentor profile.',
  adminPublishedProfile: 'Published profile',
  adminPendingRevision: 'Pending revision',
  adminProfessionalTitle: 'Professional title',
  adminHourlyRate: 'Hourly rate',
  adminApproveProfile: 'Approve profile',
  adminApproveRevision: 'Approve revision',
  adminApproveProfileTitle: 'Approve profile?',
  adminApproveProfileBody:
    'The profile will become publicly visible (subject to other moderation rules).',
  adminRestoreProfileTitle: 'Restore profile?',
  adminRestoreProfileBody: 'The profile will be restored to approved visibility.',
  adminRequestChangesTitle: 'Request changes',
  adminRejectProfileTitle: 'Reject profile',
  adminHideProfileTitle: 'Hide profile',
  adminListingsSubtitle: 'Review and moderate mentor listings',
  adminListingsLoadError: 'Could not load listings.',
  adminListingsEmpty: 'No listings match your filters.',
  adminListingLoadError: 'Could not load listing.',
  adminApproveListingTitle: 'Approve listing?',
  adminApproveListingBody:
    'The listing will be eligible for public display when availability is active.',
  adminRestoreListingTitle: 'Restore listing?',
  adminRestoreListingBody: 'The listing will be restored to approved status.',
  adminRejectListingTitle: 'Reject listing',
  adminHideListingTitle: 'Hide listing',
  adminUsersSubtitle: 'Suspend or reactivate user accounts',
  adminUsersLoadError: 'Could not load users.',
  adminUsersEmpty: 'No users match your filters.',
  adminUserLoadError: 'Could not load user.',
  adminSuspendUser: 'Suspend user',
  adminReactivateUser: 'Reactivate user',
  adminSuspendUserTitle: 'Suspend user',
  adminReactivateUserTitle: 'Reactivate user?',
  adminReactivateUserBody: 'This user will regain access to the platform.',
  adminUserSuspended: 'User suspended.',
  adminUserReactivated: 'User reactivated.',
  adminFilterAllStatuses: 'All statuses',
  adminFilterAllReviewTypes: 'All review types',
  adminFilterAllRoles: 'All roles',
  adminStatusPendingReview: 'Pending review',
  adminStatusApproved: 'Approved',
  adminStatusChangesRequested: 'Changes requested',
  adminStatusRejected: 'Rejected',
  adminStatusHidden: 'Hidden by admin',
  adminStatusActive: 'Active',
  adminStatusSuspended: 'Suspended',
  adminReviewInitial: 'Initial submission',
  adminReviewRevision: 'Profile revision',
  adminRoleAdmin: 'Admin',
  yes: 'Yes',
  no: 'No',
  // Public discovery / moderation-aware copy
  mentorUnavailable: 'This mentor profile is no longer available.',
  listingUnavailable: 'This listing is no longer available.',
  savedMentorUnavailable: 'This mentor is currently unavailable.',
  profileModerationStatus: 'Profile moderation',
  listingModerationStatus: 'Listing moderation',
  profilePendingRevisionNotice:
    'Your current profile is still visible. Your edited profile is waiting for review.',
  listingSubmittedForReview:
    'Listing submitted for review. It will appear publicly after admin approval.',
  listingDescriptionSentForReview: 'Your listing description was updated and sent for review.',
  listingUpdatedNoReview: 'Listing updated successfully.',
  availabilityUpdated: 'Availability updated successfully.',
  cannotToggleHiddenListing: 'This listing is hidden by administration and cannot be activated.',
  moderationStatusDraft: 'Draft',
  moderationStatusPendingReview: 'Pending review',
  moderationStatusApproved: 'Approved',
  moderationStatusChangesRequested: 'Changes requested',
  moderationStatusRejected: 'Rejected',
  moderationStatusHidden: 'Hidden by admin',
  // Mentor discovery swipe
  navMentorDiscovery: 'Discover Mentors',
  discoveryPageTitle: 'Find Your Mentor',
  discoveryPageSubtitle:
    'Swipe through verified mentors and find the right match for your learning journey.',
  discoverySearchPlaceholder: 'Search by subject or mentor name',
  savedMentors: 'Saved mentors',
  savedMentorsSubtitle: 'Mentors you bookmarked for later',
  backToDiscovery: 'Back to discovery',
  backToSearch: 'Back to search',
  startDiscovery: 'Start discovering',
  noSavedMentors: 'No saved mentors yet',
  noSavedMentorsHint: 'Save mentors while browsing to find them here.',
  discoveryEndOfFeed: "You've viewed all mentors in this batch.",
  discoveryEndOfFeedHint: 'Load more mentors or start over from the beginning.',
  discoveryAllSeenTitle: 'No new mentors right now',
  discoveryAllSeenHint:
    'You may have already viewed all eligible mentors in discovery. Show them again or use mentor search for more options.',
  discoveryShowAgain: 'Show mentors again',
  discoveryStartOver: 'Start over',
  discoveryBrowseSearch: 'Browse mentor search',
  discoveryCardProgress: '{{current}} of {{total}}',
  discoveryViewProfile: 'View profile',
  discoverySaveForLater: 'Save for later',
  discoveryPrevious: 'Previous',
  discoveryNext: 'Next',
  noMentorsFoundFilters: 'No mentors found for these filters.',
  tryChangingFilters: 'Try changing your subject, grade level, or teaching format.',
  subjects: 'Subjects',
  teachingStyle: 'Teaching style',
  verified: 'Verified',
  reviews: 'reviews',
  parentReview: 'Parent review',
  successStory: 'Success',
  skip: 'Skip',
  liked: 'Liked',
  skipMentor: 'Skip mentor',
  likeMentor: 'Like mentor',
  saveMentor: 'Save mentor',
  unsaveMentor: 'Unsave mentor',
  openMentorProfile: 'Open profile for',
  viewProfile: 'View profile',
  removeFromSaved: 'Remove from saved',
  mentorSaved: 'Mentor saved',
  mentorUnsaved: 'Removed from saved',
  likedMentorTitle: 'Liked!',
  likedMentorHint: 'Would you like to request a trial lesson with this mentor?',
  continueBrowsing: 'Continue browsing',
  requestTrialLesson: 'Request trial lesson',
  filters: 'Filters',
  applyFilters: 'Apply filters',
  clearAll: 'Clear all',
  examType: 'Exam type',
  gradeLevel: 'Grade level',
  teachingFormat: 'Teaching format',
  minRating: 'Minimum rating',
  allFormats: 'All formats',
  anyRating: 'Any rating',
  anyFormat: 'Any format',
  formatOnline: 'Online',
  formatInPerson: 'In person',
  formatHybrid: 'Hybrid',
  actionFailed: 'Something went wrong. Please try again.',
  contactMentorTitle: 'Contact mentor',
  contactMentorIntro: 'Send a request to {name}. They will review and respond.',
  requestType: 'Request type',
  requestTypeTrial: 'Trial lesson',
  requestTypeContact: 'Contact',
  requestTypeRegular: 'Regular lesson',
  fieldRequired: 'This field is required',
  preferredDays: 'Preferred days',
  preferredDaysHint: 'e.g. Monday, Wednesday',
  preferredTimeSlots: 'Preferred time slots',
  preferredTimeSlotsHint: 'e.g. 18:00-20:00',
  contactMessagePlaceholder: 'Tell the mentor what kind of support you are looking for.',
  messageLabel: 'Message',
  sendRequest: 'Send request',
  close: 'Close',
  contactRequestSuccessTitle: 'Your request has been sent successfully.',
  contactRequestSuccessBody: 'We will notify you when the mentor responds.',
  contactNoLinkedStudents:
    'Add a linked student before sending a mentor request. Go to My Students to create or link one.',
  leaveAReview: 'Leave a review',
  referenceModalTitle: 'Share your experience',
  referenceTypeReview: 'Review',
  referenceTypeSuccessStory: 'Success story',
  referenceTitleLabel: 'Title (optional)',
  referenceContentLabel: 'Your review',
  referenceContentHint: 'At least 10 characters.',
  referenceRatingLabel: 'Rating (optional)',
  referenceAchievementNameLabel: 'Achievement',
  referenceAchievementNamePlaceholder: 'e.g. Got into XYZ University',
  referenceAchievementYearLabel: 'Year',
  referenceDisplayNameLabel: 'Show my name as',
  referenceDisplayAsParent: 'A Parent',
  referenceDisplayAsStudent: 'A Student',
  referenceDisplayAsAnonymous: 'Anonymous',
  referenceDisplayCustomOption: 'Custom',
  referenceDisplayCustomPlaceholder: 'Enter a display name',
  referenceConsentLabel: "I agree to have this review displayed publicly on the mentor's profile.",
  referenceSubmit: 'Submit review',
  referenceSubmitSuccessTitle: 'Thank you!',
  referenceSubmitSuccessBody:
    'Your review has been submitted and will appear after the mentor reviews it.',
  referenceSubmitFailed: 'Could not submit your review',
  referenceContentTooShort: 'Please write at least 10 characters',
  referenceConsentRequired: 'You must agree to display this review to submit it',
  mentorReferencesTitle: 'References',
  mentorReferencesSubtitle: 'Reviews and success stories submitted about you.',
  referencesTabPending: 'Pending',
  referencesTabApproved: 'Approved',
  referencesTabHidden: 'Hidden',
  referenceApprove: 'Approve',
  referenceHide: 'Hide',
  referencesEmpty: 'No references here yet.',
  referenceUpdateFailed: 'Could not update this reference',
  referencesLoadFailed: 'Could not load references',
  navReferences: 'References',
  completeVerification: 'Complete verification',
  verificationOnboardingTitle: 'Get verified',
  verificationOnboardingSubtitle: 'Complete these steps to unlock your full mentor dashboard.',
  verificationStepEmail: 'Email verified',
  verificationStepIdentity: 'Identity verification',
  verificationStepDocuments: 'Academic proof',
  verificationSkipForNow: 'Skip for now',
  verificationContinue: 'Continue',
  verificationEmailConfirmed: 'Your email has been confirmed: {{email}}',
  verificationIdentityVerifiedMsg: 'Your identity has been verified.',
  verificationIdentityInProgress: 'Identity verification is in progress.',
  verificationIdentityFailedMsg: 'Verification failed — please try again.',
  verificationIdentityPrompt: 'Verify your legal identity via our secure partner.',
  verificationAcademicLocked: 'Verify your identity first to unlock this step.',
  verificationStudentEmailAutoApproved:
    'Your university email is auto-approved — no upload needed.',
  verificationAcademicApproved: 'Your academic proof has been approved.',
  verificationAcademicUnderReview: 'Your academic proof is under review.',
  verificationAcademicRejected: 'Your academic proof was rejected.',
  verificationAcademicRejectedWithNotes: 'Your academic proof was rejected: {{notes}}',
  verificationAcademicUploadPrompt: 'Upload your academic proof to continue.',
  verificationInfoRestrictedIdentity:
    'Complete identity verification to unlock your dashboard, lessons, materials, earnings, and other mentor features.',
  verificationInfoPendingReview:
    'Your dashboard and other mentor features stay locked until this review is complete.',
  verificationInfoRestrictedOther:
    'Finish the steps above to unlock your dashboard and other mentor features.',
  verificationCheckStatus: 'Check verification status',
  verificationVerifyIdentityButton: 'Verify identity',
  verificationIllDoLater: "I'll do this later",
  verificationStatusNotStarted: 'Not started',
  verificationStatusPending: 'Pending review',
  verificationStatusVerified: 'Verified',
  verificationStatusFailed: 'Failed',
  verificationStatusApproved: 'Approved',
  verificationStatusRejected: 'Rejected',
  verificationStatusNotRequired: 'Not required',
  verificationFullyActive: 'Verified & active',
  verificationFullyActiveBody: 'Your account is fully verified. All mentor features are unlocked.',
  verificationActionRequired: 'Action required',
  verificationPendingReviewBadge: 'Pending review',
  verificationAcademicComplete: 'Academic verification complete',
  verificationPanelTitle: 'Verification status',
  identityVerificationTitle: 'Identity verification',
  identityVerificationBody:
    'Verify your identity to build trust with parents and students. This opens a secure verification session in a new tab.',
  identityStartButton: 'Start verification',
  identityRestartButton: 'Restart verification',
  identityRefreshStatus: 'Refresh status',
  identityOpenedHint:
    'Complete the verification in the new tab, then come back and refresh your status.',
  documentUploadTitle: 'Academic proof',
  documentUploadBody:
    'Upload a document proving your academic background (graduation certificate, diploma, or enrollment letter).',
  documentTypeGraduationCertificate: 'Graduation certificate',
  documentTypeDiploma: 'Diploma',
  documentTypeEnrollmentLetter: 'Enrollment letter',
  documentTypeOther: 'Other',
  documentUploadButton: 'Upload document',
  documentUploadHint: 'PDF, JPEG, PNG or WEBP, up to 8MB.',
  documentFileTooLarge: 'File is too large. Maximum size is 8MB.',
  documentFileTypeInvalid: 'Unsupported file type. Use PDF, JPEG, PNG or WEBP.',
  documentUploadFailed: 'Could not upload document',
  documentUploadSuccess: 'Document uploaded — pending review.',
  documentsListTitle: 'Your uploads',
  documentsEmpty: 'No documents uploaded yet.',
  verificationStatusLoadFailed: 'Could not load verification status',
  identityStartFailed: 'Could not start identity verification',
  navPricing: 'Pricing',
  navMediaGallery: 'Media Gallery',
  mediaGalleryTitle: 'Media Gallery',
  mediaGalleryDescription: 'Manage the photos and intro video shown on your public profile.',
  mentorPricingTitle: 'Pricing',
  mentorPricingSubtitle: 'Set your hourly rate and lesson packages.',
  pricingCurrencyLabel: 'Currency',
  pricingHourlyRateLabel: 'Hourly rate',
  pricingTrialPriceLabel: 'Trial lesson price',
  pricingPublicToggleLabel: 'Show pricing publicly on my profile',
  pricingPackagesTitle: 'Packages',
  pricingPackageNameLabel: 'Package name',
  pricingPackageLessonsLabel: 'Lessons',
  pricingPackagePriceLabel: 'Price',
  pricingAddPackage: 'Add package',
  pricingRemovePackage: 'Remove',
  pricingSave: 'Save pricing',
  pricingSaveSuccess: 'Pricing updated',
  pricingSaveFailed: 'Could not update pricing',
  mentorMediaGalleryTitle: 'Profile photos',
  mentorMediaGalleryHint: 'Up to 5 photos. JPG, PNG or WebP, up to 5MB each.',
  mentorMediaUpload: 'Upload photo',
  mentorMediaPrimaryBadge: 'Primary',
  mentorMediaDelete: 'Delete',
  mentorMediaUploadFailed: 'Could not upload photo',
  mentorMediaDeleteFailed: 'Could not delete photo',
  mentorMediaMaxReached: 'You have reached the maximum of 5 photos',
  mentorMediaEmpty: 'No photos uploaded yet.',
  mentorMediaCount: '{{count}} photo(s) uploaded',
  introVideoTitle: 'Intro video',
  introVideoHint:
    'Add a direct link to a short intro video file (.mp4, .webm — not a YouTube or Vimeo page link). It will be reviewed before it appears on your public profile.',
  introVideoUrlLabel: 'Video URL',
  introVideoUrlPlaceholder: 'https://...',
  introVideoUrlInvalid: 'Enter a valid video URL',
  introVideoReplace: 'Replace',
  introVideoSaveSuccess: 'Intro video submitted for review',
  introVideoSaveFailed: 'Could not save intro video',
  reportProfile: 'Report profile',
  reportReason: 'Reason',
  reportReasonInappropriate: 'Inappropriate content',
  reportReasonFalseInfo: 'False information',
  reportReasonSafety: 'Safety concern',
  reportReasonSpam: 'Spam',
  reportReasonOther: 'Other',
  additionalDetails: 'Additional details (optional)',
  submitReport: 'Submit report',
  reportSubmitted: 'Report submitted',
  reportThankYou: 'Thank you. Our team will review this report.',
  subjectField: 'Subject',
  department: 'Department',
  degree: 'Degree',
  graduationYear: 'Graduation year',
  highSchool: 'High school',
  professionalTitle: 'Professional title',
  professionalTitlePlaceholder: 'e.g. Mathematics Tutor, Software Engineer',
  profileSlogan: 'Profile slogan',
  longBio: 'Long bio',
  longBioPlaceholder: 'Tell students more about your teaching background and approach.',
  teachingExperience: 'Teaching experience',
  teachingExperiencePlaceholder: 'e.g. 5 years of math tutoring',
  certifications: 'Certifications',
  addCertificationPlaceholder: 'Add a certification',
  add: 'Add',
  teachingFormats: 'Teaching formats',
  teachingFormatOnline: 'Online',
  teachingFormatInPerson: 'In person',
  teachingFormatHybrid: 'Hybrid',
  teachingStyleTagPatient: 'Patient',
  teachingStyleTagMotivating: 'Motivating',
  teachingStyleTagDisciplined: 'Disciplined',
  teachingStyleTagFriendly: 'Friendly',
  teachingStyleTagExamOriented: 'Exam-oriented',
  teachingStyleTagSupportive: 'Supportive',
  teachingStyleTagStructured: 'Structured',
  teachingStyleTagFun: 'Fun',
  teachingStyleTagCalm: 'Calm',
  teachingStyleTagEnergetic: 'Energetic',
  teachingStyleTagGoalOriented: 'Goal-oriented',
  expertise: 'Expertise',
  introVideo: 'Intro video',
  playVideo: 'Play video',
  noReviewsYet: 'No reviews yet.',
  successStories: 'Success stories',
  noSuccessStories: 'No success stories yet.',
  pricing: 'Pricing',
  hourlyRate: 'Hourly rate',
  pricingHidden: 'Pricing information will be shared after request.',
  myMentorRequests: 'My mentor requests',
  myMentorRequestsSubtitle: 'Track contact and trial lesson requests',
  noMentorRequests: 'You have not submitted any mentor requests yet.',
  noMentorRequestsHint: 'Request a trial lesson from a mentor profile to get started.',
  loadError: 'Something went wrong. Please try again.',
  created: 'Created',
  cancelRequest: 'Cancel request',
  requestCancelled: 'Request cancelled',
  mentorContactRequests: 'Contact Requests',
  mentorContactRequestsSubtitle: 'Review and manage requests from parents and students.',
  noIncomingRequests: 'No incoming requests.',
  rejectRequest: 'Reject request',
  requestAccepted: 'Request accepted',
  requestRejected: 'Request rejected',
  acceptRequest: 'Accept',
  rejectRequestBtn: 'Reject',
  markCompleted: 'Mark completed',
  statusPending: 'Pending',
  statusAccepted: 'Accepted',
  statusRejected: 'Declined',
  statusCancelled: 'Cancelled',
  statusCompleted: 'Completed',
  contactRequestsTabAll: 'All',
  contactRequestsSearchPlaceholder: 'Search by student or parent name',
  contactRequestsFilterSubjectAll: 'All subjects',
  contactRequestsFilterGradeAll: 'All grades',
  contactRequestsSortLabel: 'Sort',
  contactRequestsSortNewest: 'Newest first',
  contactRequestsSortOldest: 'Oldest first',
  contactRequestParentLabel: 'Parent: {{name}}',
  contactRequestViewDetails: 'View details',
  contactRequestDetailsTitle: 'Request details',
  contactRequestSubmittedLabel: 'Submitted',
  contactRequestStatusLabel: 'Status',
  contactRequestMentorResponseLabel: 'Your response',
  contactRequestRespondedAtLabel: 'Responded',
  contactRequestNoMessage: 'No message provided.',
  contactRequestsEmptyAllTitle: 'No requests yet',
  contactRequestsEmptyAllBody: 'New requests from parents and students will appear here.',
  contactRequestsEmptyPendingTitle: 'No pending requests',
  contactRequestsEmptyPendingBody: 'New requests from parents and students will appear here.',
  contactRequestsEmptyStatusTitle: 'No requests here yet',
  contactRequestsEmptyStatusBody: 'Requests with this status will appear here.',
  contactRequestsEmptyFilteredTitle: 'No requests match your filters',
  contactRequestsEmptyFilteredBody: 'Try a different search term or clear your filters.',
  adminContactRequests: 'Mentor contact requests',
  adminContactRequestsSubtitle: 'View and manage all contact requests',
  adminNoContactRequests: 'No contact requests found.',
  adminActionSuccess: 'Updated successfully.',
  adminReportsSubtitle: 'Review user-submitted content reports',
  adminNoReports: 'No reports found.',
  reportStatusOpen: 'Open',
  reportStatusUnderReview: 'Under review',
  reportStatusResolved: 'Resolved',
  reportStatusDismissed: 'Dismissed',
  markUnderReview: 'Mark under review',
  resolve: 'Resolve',
  dismiss: 'Dismiss',
  mentorLabel: 'Mentor',
  // Marketing / sponsored campaigns
  adminNavMarketing: 'Marketing Management',
  marketingCampaignsSubtitle: 'Create and manage sponsored educational campaigns',
  marketingCampaignsLoadError: 'Could not load campaigns.',
  marketingCampaignsEmpty: 'No campaigns yet.',
  marketingCreateCampaign: 'Create campaign',
  marketingCreateSubtitle: 'Configure placements, targeting, and schedule for a sponsored card.',
  marketingEditCampaign: 'Edit campaign',
  marketingCampaignDetail: 'Campaign details',
  marketingCampaignLoadError: 'Could not load campaign.',
  marketingCampaignCreated: 'Campaign created.',
  marketingCampaignUpdated: 'Campaign updated.',
  marketingCampaignPaused: 'Campaign paused.',
  marketingCampaignEnded: 'Campaign ended.',
  marketingCampaignDeleted: 'Campaign archived.',
  marketingDeleteTitle: 'Archive campaign?',
  marketingDeleteBody:
    'This campaign will be removed from public delivery. You can create a new one later.',
  marketingMetrics: 'Metrics',
  marketingMetricsLoadError: 'Could not load campaign metrics.',
  marketingMetricsByPlacement: 'By placement',
  marketingMetricsByPlatform: 'By platform',
  marketingMetricsStartDate: 'Start date',
  marketingMetricsEndDate: 'End date',
  marketingMetricsDateRange: 'Date range',
  marketingNoMetrics: 'No metrics for this range.',
  marketingColCampaignName: 'Campaign',
  marketingColSponsor: 'Sponsor',
  marketingColDates: 'Schedule',
  marketingColPlacements: 'Placements',
  marketingColRoles: 'Target roles',
  marketingColImpressions: 'Impressions',
  marketingColClicks: 'Clicks',
  marketingColCtr: 'CTR',
  marketingColPerformance: 'Performance',
  marketingActionPause: 'Pause',
  marketingActionActivate: 'Activate',
  marketingActionEnd: 'End',
  marketingPauseBeforeEdit: 'Pause before editing',
  marketingStatusDraft: 'Draft',
  marketingStatusActive: 'Active',
  marketingStatusPaused: 'Paused',
  marketingStatusDeleted: 'Archived',
  marketingStatusEnded: 'Ended',
  marketingSectionBasicInfo: 'Basic information',
  marketingSectionPlacements: 'Where should this appear?',
  marketingSectionTargeting: 'Targeting',
  marketingSectionSchedule: 'Schedule & status',
  marketingPlacementsHint: 'Select one or more screens where this sponsored card may appear.',
  marketingFieldInternalName: 'Campaign name (internal)',
  marketingFieldTitle: 'Card title',
  marketingFieldSubtitle: 'Subtitle',
  marketingFieldDescription: 'Description',
  marketingFieldImageUrl: 'Campaign image URL',
  marketingFieldSponsorLabel: 'Sponsor / company name',
  marketingFieldBadgeText: 'Sponsored badge text',
  marketingFieldCtaText: 'CTA button text',
  marketingFieldCtaUrl: 'CTA link URL',
  marketingFieldLanguage: 'Language',
  marketingFieldGeneralCampaign: 'General campaign (no grade/subject targeting)',
  marketingFieldTargetGrade: 'Target grade',
  marketingFieldTargetSubject: 'Target subject',
  marketingFieldTargetExam: 'Target exam type',
  marketingFieldMinAge: 'Minimum age',
  marketingFieldMaxAge: 'Maximum age',
  marketingFieldStartDate: 'Start date',
  marketingFieldEndDate: 'End date',
  marketingFieldStatus: 'Status',
  marketingFieldPlatform: 'Platform',
  marketingFieldPriority: 'Priority',
  marketingFieldPriorityValue: 'Priority (0–100)',
  marketingLanguageEn: 'English',
  marketingLanguageTr: 'Turkish',
  marketingPlatformWeb: 'Web',
  marketingPlatformIos: 'iOS',
  marketingPlatformAndroid: 'Android',
  marketingPlatformAll: 'All platforms',
  marketingPriorityLow: 'Low',
  marketingPriorityNormal: 'Normal',
  marketingPriorityHigh: 'High',
  marketingPriorityCustom: 'Custom',
  marketingRoleParent: 'Parent',
  marketingRoleStudent: 'Student',
  marketingRoleMentor: 'Mentor',
  marketingPlacementSearchResults: 'Mentor search results',
  marketingPlacementDiscoveryFeed: 'Mentor discovery',
  marketingPlacementLessonsPage: 'Booking / lessons success',
  marketingPlacementStudentDashboard: 'Student dashboard — sponsored resources',
  marketingPlacementParentDashboard: 'Parent dashboard — sponsored resources',
  marketingPlacementMentorDashboard: 'Mentor dashboard',
  marketingAnyGrade: 'Any grade',
  marketingAnyExam: 'Any exam',
  marketingGradeN: 'Grade {{n}}',
  marketingSectionCampaignContent: 'Campaign content',
  marketingSectionDeliverySettings: 'Delivery settings',
  marketingContentLanguageNote:
    'Title, description, and button text are stored in the campaign delivery language below. They do not change when you switch the admin interface language.',
  marketingFieldLanguageHint:
    'Users only see this campaign when their app language matches this setting. Write all card text in that language.',
  marketingFieldDescriptionHint: 'Write in the same language as the delivery language above.',
  marketingDeliveryLanguageBadge: 'Delivery language: {{language}}',
  marketingPreviewTitle: 'Card preview',
  marketingPreviewTitlePlaceholder: 'Campaign title preview',
  marketingSponsoredLabel: 'Sponsored',
  marketingSponsoredAria: 'Sponsored educational resource',
  marketingDefaultCta: 'Learn more',
  marketingDashboardSectionTitle: 'Sponsored resources',
  marketingValidationEndBeforeStart: 'End date must be on or after the start date.',
  marketingValidationActiveNoPlacement: 'Active campaigns need at least one placement.',
  marketingValidationActiveNoRole: 'Active campaigns need at least one target role.',
  marketingValidationAgeRange: 'Minimum age cannot exceed maximum age.',
  marketingValidationGeneralTargeting: 'General campaigns cannot include specific targeting.',
  delete: 'Delete',
  saveChanges: 'Save changes',
  confirmPassword: 'Confirm password',
  termsAccepted: 'I accept the terms of service',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms and Conditions',
  legalBackToHome: '← Back to home',
  legalLastUpdated: 'Last updated',
  registerLegalAgreementPrefix: 'By registering, you agree to our',
  registerLegalAgreementJoiner: 'and',
  registerSuccess:
    'Registration received. Use the mobile app for verification steps, or try signing in.',
  registerFailed: 'Registration failed',
  validationEmailOrPhoneRequired: 'Email or phone is required',
  validationPasswordRequired: 'Password is required',
  validationEmailRequired: 'Email is required',
  validationEmailInvalid: 'Enter a valid email',
  validationPhoneRequired: 'Phone number is required',
  validationPasswordMinLength: 'At least 8 characters',
  validationPasswordComplexity:
    'Password must include an uppercase letter, a number, and a special character',
  validationConfirmPasswordRequired: 'Please confirm your password',
  validationPasswordsMismatch: 'Passwords do not match',
  validationTermsRequired: 'You must accept the terms',
  validationEnterValidAmount: 'Please enter a valid amount.',
  validationAmountGreaterThanZero: 'Amount must be greater than 0.',
  studentsPageTitle: 'My Students',
  studentsPageDescription: 'Manage students linked to your account.',
  studentsAdd: 'Add Student',
  studentsLoadError: 'Could not load students',
  studentsEmptyTitle: 'No students added yet',
  studentsEmptyDescription: 'Add your child to start booking lessons.',
  studentsModalTitle: 'Add New Student',
  studentsCreate: 'Create Student',
  studentsCreatedSuccess: 'Student created. A verification notification was sent to the student.',
  studentsCreateFailed: 'Could not create student',
  studentsGradeLabel: 'Grade: {{grade}}',
  studentsVerificationHint:
    'After creating the account, the student will receive a verification notification.',
  school: 'School',
  schoolNamePlaceholder: 'School name',
  grade: 'Grade',
  gradeLevelPlaceholder: 'e.g. Grade 10',
  listingDescriptionLabel: 'Description ({{count}}/1000)',
  listingDescriptionPlaceholder:
    'Describe your teaching style, experience, and what students will learn...',
  listingValidationSubjectRequired: 'Please select a subject',
  listingValidationGradeRequired: 'Select at least one grade level',
  listingValidationGradeDuplicate: 'Grade levels cannot contain duplicates',
  listingValidationFormatRequired: 'Please select a lesson format',
  listingValidationDescriptionMin: 'Description must be at least 50 characters',
  listingValidationDescriptionMax: 'Description must be at most 1000 characters',
  parentWalletPageDescription: 'Your lesson credits and wallet activity.',
  parentWalletLoadError: 'Could not load wallet',
  parentWalletAvailableCredits: 'Available Credits',
  parentWalletCreditsReadyToBook: 'credits ready to book',
  parentWalletHeld: 'Held',
  parentWalletForBookings: 'for bookings',
  parentWalletTotal: 'Total',
  parentWalletAvailablePlusHeld: 'available + held',
  parentWalletPurchased: 'Purchased',
  parentWalletUsed: 'Used',
  parentWalletRefunded: 'Refunded',
  parentWalletBonus: 'Bonus',
  parentWalletAddCreditsCta: 'Top up your credit balance to book lessons.',
  parentWalletCreditActivity: 'Credit Activity',
  parentWalletTxLoadError: 'Could not load transactions',
  parentWalletEmptyTitle: 'No wallet activity yet',
  parentWalletEmptyDescription: 'Your credit purchases and lesson bookings will appear here.',
  parentWalletCurrentBalance: 'Current Balance',
  parentWalletEnterAmount: 'Enter credit amount',
  creditsLabel: 'credits',
  parentWalletCreditsHelper:
    'Credits are added to your account immediately. Use them to book lessons with any mentor.',
  parentWalletCreditsAdded: 'Credits added successfully.',
  parentWalletCreditsAddFailed: 'Failed to add credits. Please try again.',
  paginationPrevious: 'Previous',
  paginationNext: 'Next',
  txDummyTopup: 'Credits added',
  txCreditPurchase: 'Credits purchased',
  txBonusCredit: 'Bonus credits',
  txManualAdjustmentAdd: 'Manual credit adjustment',
  txManualAdjustmentRemove: 'Manual credit deduction',
  txCreditHold: 'Credits held',
  txCreditRelease: 'Credits released',
  txCreditSpent: 'Credits spent',
  txCreditRefund: 'Credits refunded',
  txBookingReversal: 'Booking reversal',
  txSystemCorrection: 'System correction',
  txWalletActivity: 'Wallet activity',
  creditAmountHeld: '{{count}} credits held',
  creditAmountReturned: '+{{count}} credits returned',
  creditAmountPositive: '+{{count}} credits',
  creditAmountNegative: '-{{count}} credits',
  photoPrevious: 'Previous photo',
  photoNext: 'Next photo',
  refreshListings: 'Refresh listings',
  comingSoonTitle: 'Coming soon',
  comingSoonDescription:
    'This section can be extended to connect to the same APIs as the mobile app.',
  urlPlaceholder: 'https://',
  toggleMenu: 'Toggle menu',
  closeAria: 'Close',
  loadingAria: 'Loading',
  switchToEnglish: 'Switch to English',
  switchToTurkish: 'Switch to Turkish',
  filterChemistry: 'Chemistry',
  filterBiology: 'Biology',
  filterEnglish: 'English',
  stylePatient: 'Patient',
  styleMotivating: 'Motivating',
  styleDisciplined: 'Disciplined',
  styleFriendly: 'Friendly',
  styleExamOriented: 'Exam-oriented',
  styleSupportive: 'Supportive',
  styleStructured: 'Structured',
  styleFun: 'Fun',
  styleCalm: 'Calm',
  styleEnergetic: 'Energetic',
  styleGoalOriented: 'Goal-oriented',
  readMore: 'Read more',
  showLess: 'Show less',
  bookingCreditsUsed: 'Credits used',
  bookingRemainingBalance: 'Remaining balance',
  dashboardTotal: 'Total',
  dashboardAvailableShort: 'Available',
  dashboardBookedPercent: '{{percent}}% booked',
  dashboardStatTodayLessons: "Today's Lessons",
  dashboardStatPendingRequests: 'Pending Requests',
  dashboardStatActiveListings: 'Active Listings',
  dashboardStatUnreadMessages: 'Unread Messages',
  dashboardStatAvailablePayout: 'Available for Payout',
  dashboardTodayPreview: 'Today',
  dashboardThisWeekPreview: 'This Week',
  dashboardNoLessonsToday: 'No lessons today',
  dashboardTodayLessonCount: '{{count}} lessons today',
  dashboardTodayLessonOne: '1 lesson today',
  dashboardWeekUpcomingCount: '{{count}} upcoming lessons',
  dashboardWeekUpcomingOne: '1 upcoming lesson',
  dashboardNoUpcomingThisWeek: 'No upcoming lessons this week',
  dashboardQuickSetAvailability: 'Set Availability',
  dashboardQuickCreateListing: 'Create Listing',
  dashboardQuickUploadMaterial: 'Upload Material',
  dashboardQuickContactRequests: 'View Contact Requests',
  dashboardQuickEarnings: 'View Earnings',
  dashboardPendingWorkTitle: 'Action needed',
  dashboardCaughtUp: "You're all caught up.",
  dashboardPendingContactRequests: '{{count}} contact requests pending',
  dashboardPendingContactRequestOne: '1 contact request pending',
  dashboardPendingProfileRevision: 'Profile edit waiting for review',
  dashboardPendingSubmissions: '{{count}} assignments waiting for review',
  dashboardPendingSubmissionOne: '1 assignment waiting for review',
  dashboardEarningsAvailable: 'Available for payout',
  dashboardEarningsPending: 'Pending',
  dashboardViewLessons: 'View Lessons',
  dashboardSetAvailability: 'Set Availability',
  lessonsPageDescriptionMentor: 'Manage your upcoming and past lessons from here.',
  parentStatUpcomingLessons: 'Upcoming Lessons',
  parentStatCreditBalance: 'Credit Balance',
  parentStatUnreadMessages: 'Unread Messages',
  parentStatLinkedStudents: 'Linked Students',
  parentQuickFindMentor: 'Find a Mentor',
  parentQuickViewLessons: 'View Lessons',
  parentQuickMaterials: 'View Materials',
  parentQuickAddCredits: 'Add Credits',
  parentQuickMyStudents: 'My Students',
  studentsStatTotal: 'Total Students',
  studentsCardViewLessons: 'Lessons',
  studentsCardViewMaterials: 'Materials',
  studentsCardFavourites: 'Favourites',
  studentsNoGrade: 'Grade not set',
  materialStatAssignmentsParent: 'Assignments',
  materialStatResourcesParent: 'Course Resources',
  materialStatSubmitted: 'Submitted',
  materialStatNotSubmitted: 'Not Submitted',
  profileSectionLinkedStudents: 'Linked Students',
  profileSectionWallet: 'Wallet',
  parentWalletPreviewHint: 'View balance and add credits',
  profileMenuMyStudents: 'My Students',
  profileMenuWallet: 'Wallet',
  lessonsStatToday: "Today's Lessons",
  lessonsStatReportsPending: 'Reports Pending',
  noUpcomingLessonsMentorDescription:
    'New bookings will appear here when students schedule a lesson.',
  noPastLessonsMentorDescription:
    'Completed lessons and reports will appear here after your sessions.',
  lessonsViewUpcoming: 'View Upcoming Lessons',
  lessonsViewContactRequests: 'View Contact Requests',
  lessonsSetAvailability: 'Set Availability',
  listingsVerificationRequiredTitle: 'Verification required',
  listingsVerificationRequiredBody:
    'Complete identity and student status verification before managing lesson listings. Use the Mentora mobile app to finish verification.',
  listingSetInactive: 'Set listing inactive',
  listingSetActive: 'Set listing active',
  requestFailed: 'Request failed',
  reportFailed: 'Report failed',
  recordingConsentSaveFailed: 'Could not save recording consent.',
  reviewCount: '{{count}} reviews',
  emailPlaceholder: 'you@example.com',
  passwordPlaceholder: '••••••••',
  otpPlaceholder: '000000',
  mentorWalletIbanPlaceholder: 'TR…',
  messagesUnreadBadge: '{{count}} unread messages',
  languageSwitcherAria: 'Select language',
  themeLight: 'Light mode',
  themeDark: 'Dark mode',
  themeSwitchToLight: 'Switch to light mode',
  themeSwitchToDark: 'Switch to dark mode',
  verificationIdentityVerified: 'Identity verified',
  verificationEducationVerified: 'Education verified',
  verificationBackgroundChecked: 'Background checked',
  verificationReferencesChecked: 'References checked',
  successCategorySchoolAdmission: 'School Admission',
  successCategoryExamSuccess: 'Exam Success',
  successCategoryGradeImprovement: 'Grade Improvement',
  successCategoryGeneralProgress: 'General Progress',
  successCategoryOther: 'Other',
  mentorProfileNewNoReviews: 'New mentor · No reviews yet',
  aboutMentorName: 'About {{name}}',
  requestLesson: 'Request a Lesson',
  profileNavOverview: 'Overview',
  profileNavSubjects: 'Subjects',
  profileNavTeachingStyle: 'Teaching Style',
  profileNavServices: 'Services',
  profileNavAvailability: 'Availability',
  profileNavVideo: 'Video',
  profileNavEducation: 'Education',
  profileNavReviews: 'Reviews',
  profileNavSuccessStories: 'Success Stories',
  profileSectionNavAriaLabel: 'Profile sections',
  profileSubjectsHeading: 'Subjects and Supported Levels',
  profileLevelsLabel: 'Supported levels',
  profileExamTypesLabel: 'Exam preparation',
  profileAvailabilityFormatsLabel: 'Available lesson formats',
  profileAvailabilityEarliestLabel: 'Earliest availability',
  profileAvailabilityNoSlots:
    'No upcoming availability shown yet. Send a request to check timing with the mentor.',
  profileVideoLoading: 'Loading video…',
  profileVideoError: 'This video could not be played.',
  pricingSharedAfterReview: 'Lesson price will be shared after the mentor reviews your request.',
  profileReviewsViewAll: 'View all reviews',
  profileReviewsShowFewer: 'Show fewer',
  profileReviewVerifiedBadge: 'Verified lesson',
  profileSuccessStoriesViewAll: 'View all success stories',
  profileSuccessStoriesShowFewer: 'Show fewer',
  profileHeadlineSubjectOnly: '{{subject}} Mentor',
  profileHeadlineSubjectAndExam: '{{subject}} Mentor · {{exam}} Preparation',
  profileVideoUnavailable: 'No introduction video available.',
  profileHighlightsHeading: 'Highlights',
  profileHighlightOnlineLessons: 'Online lessons',
  profileHighlightHybridLessons: 'Hybrid lessons',
  profileHighlightInPersonLessons: 'In-person lessons',
  profileHighlightExamPrep: 'Exam preparation',
  profileEducationSectionVerified: 'Education verified',
  profileStorySharedBy: 'Shared by {{name}}',
} as const;

export type Strings = typeof en;
